import { z } from 'zod';
import { FamilyChoiceSchema } from './families.js';
import { ModelFolderNameSchema } from './models.js';
/** Freeing space on a machine (doc 47): ComfyUI's output and input folders. */
export const MachineFileKindSchema = z.enum(['output', 'input']);
/** A relative path inside the folder: no absolute paths, no "..", no backslashes or NUL. The agent checks again. */
export const RelativeFileNameSchema = z.string().min(1).max(512).refine((name) => !name.startsWith('/') && !/[\\\0]/.test(name) && !name.split('/').includes('..'), 'A file name inside the folder');
export const MachineFileSchema = z.object({
    name: z.string().min(1).max(512),
    sizeBytes: z.number().int().min(0),
    modifiedAt: z.string().max(64),
    media: z.enum(['image', 'video', 'audio']),
});
/** What the agent reports for `list_files`. Untrusted: validated before use. */
export const MachineFilesSchema = z.object({
    files: z.array(MachineFileSchema).max(5000),
    totalBytes: z.number().int().min(0),
    truncated: z.boolean(),
});
export const MAX_DELETE_FILES = 200;
export const DeleteFilesRequestSchema = z.object({
    kind: MachineFileKindSchema,
    names: z.array(RelativeFileNameSchema).min(1).max(MAX_DELETE_FILES),
});
export const DeleteFilesResponseSchema = z.object({
    deleted: z.number().int().min(0),
    missing: z.number().int().min(0),
    freedBytes: z.number().int().min(0),
});
export const DeleteModelRequestSchema = z.object({ folder: ModelFolderNameSchema, name: RelativeFileNameSchema });
export const DeleteModelResponseSchema = z.object({ deleted: z.boolean(), freedBytes: z.number().int().min(0) });
/** PUT /api/v1/machines/:id/models/family — null goes back to automatic. */
export const SetModelFamilyRequestSchema = z.object({
    folder: ModelFolderNameSchema,
    name: RelativeFileNameSchema,
    family: FamilyChoiceSchema.nullable(),
});
//# sourceMappingURL=files.js.map